export interface IFeature {
    ODB?: number | boolean;
    ODC?: string | boolean;
    OneDrive?: boolean;
    Fallback?: boolean;
}

export function isSPFeatureEnabled(feature: IFeature, expFeatures: number[]): boolean {
    let result: boolean = !!feature.Fallback;
    const odb = feature.ODB;

    if (typeof odb === 'boolean') {
        result = odb;
    } else if (odb > 0) {
        const elem = Math.floor(<number>odb / 32);
        const mask = 1 << (<number>odb % 32);

        result = (elem < expFeatures.length) &&
            (expFeatures[elem] & mask) !== 0;
    }

    return result;
}